export const businessInfoEndpointConfiguration = {
  url: '/_api/services-catalog/v1/business',
  method: 'GET',
  memoryStorageTTLInMinutes: 60
};
//# sourceMappingURL=businessInfo.js.map